var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDlpBigHighlight = function SvgDlpBigHighlight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 273,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C29B40",
    d: "M270.37 2.662 269 5.324l-232.3.033-33.3.05-.825.483C1.585 6.489.941 7.17.462 8.153.1 8.9.1 16 .05 25.135L0 34.37l.71.449c.94.582 2.146.981 3.318 1.081l.941.1v-3.045h28.776c31.335 0 228.552.05 230.583-.915.743-.35 2.526-1.764 2.691-2.13.016-.083.231-.332.462-.582.561-.599 1.123-1.863 1.601-3.643 1.569-5.607 3.88-21.775 3.913-22.457.066-1.498-.561-3.211-1.172-3.228-.05 0-.693 1.198-1.453 2.662"
  })));
};
export default SvgDlpBigHighlight;